export default function(x) {
	if( typeof x === 'string' ){
		if( !/\D/g.exec( x ) )
			x = parseInt(x);
	}
	if(typeof x !== 'number' || !isFinite(x)) {
		return;
	}
	let parts = `${x}`.split('.');
	let intPart = parts[0];
	let decPart = parts[1];
	let intPartLength = intPart.length;
	let reversedIntPart = intPart.split('').reverse().join('');
	let reversedNewIntPart = '';
	for(let i=0; i<intPartLength; i++) {
		if((i%3===0) && (i>0)) {
			reversedNewIntPart = reversedNewIntPart + '.';
		}
		reversedNewIntPart = reversedNewIntPart + reversedIntPart[i];
	}
	let newIntPart = reversedNewIntPart.split('').reverse().join('');
	return `${newIntPart}` + (decPart === undefined ? '' : `,${decPart}`);
};